import translate from "../../../common/Dictionary";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useDropzone } from 'react-dropzone';
import ShortNotice from '../ShortNotice';
import uploadIcon from "../../../../img/icon_upload.svg";
import FileIcon from "../../../../img/icon_file.svg";
import DeleteIcon from "../../../../img/icon_delete.svg";
import InfoIcon from "../../../../img/icon_info.svg";

const StepThree = ({ state, userData, setState, handleAnswer, onDrop, onRemoveFile, onNext, onBack }) => {
    const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
        onDrop,
        noClick: true,
        noKeyboard: true,
        accept: {
            'image/png': ['.png'],
            'image/jpg': ['.jpg'],
            'application/pdf': ['.pdf'],
        }
    });

    const handleFileRemove = (fileName) => {
        if (onRemoveFile) {
            onRemoveFile(fileName);
        } else {
            // Fallback to setState if onRemoveFile is not provided
            setState(prevState => ({ 
                ...prevState, 
                customerUploadedFiles: prevState.customerUploadedFiles.filter(x => x.name !== fileName) 
            }));
        }
    };

    return (
        <div className="axa-project-card">
            <div className="axa-subcat-card-padding axa-card-shadow mt-4 bg-white" >
                <div className="axa-mobile-hidden" style={{ "height": "32px" }}></div>
                <ShortNotice />
                <div className="axa-service-card-title align-left pt-5 pb-5">{translate("newProjectDetailsTitle", userData.language)}</div>
                <hr className="axa-service-card-diveder" />
                <div
                    className="axa-newproject-second-title align-left pt-4 pb-4"
                    style={{
                        display: (state.serviceCategories
                            ?.find(x => x.id === parseInt(state.selectedCatId))
                            ?.serviceSubCategories?.find(x => x.id === parseInt(state.selectedSubcatId))
                            ?.services.find(x => x.id === parseInt(state.selectedServiceId))
                            ?.serviceQuestions.length > 0 ? "" : "none")
                    }}
                >
                    {translate("newProjectDetailsSecondaryTitleSpecifics", userData.language)}
                </div>
                <div align="left">
                    {state.serviceCategories
                        ?.find(x => x.id === parseInt(state.selectedCatId))
                        ?.serviceSubCategories?.find(x => x.id === parseInt(state.selectedSubcatId))
                        ?.services.find(x => x.id === parseInt(state.selectedServiceId))
                        ?.serviceQuestions.map((serviceQuestion, index) => {
                            return (
                                <div className="mb-5" key={"serviceQuestion-" + index} align="left">
                                    <div className="axa-input-label align-left">{translate(serviceQuestion.question.questionCode, userData.language)}</div>
                                    <div>{translate("newProject-" + serviceQuestion.question.answerType + "AswerTypeDescr", userData.language)}</div>
                                    {serviceQuestion.question.answerType === "radio" ?
                                        (serviceQuestion.question.answers.map((answer) => {
                                            return (
                                                <div className="form-check" key={"questionGroup-" + answer.questionId + "-answer-" + answer.id}>
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name={"questionGroup-" + answer.questionId}
                                                        id={"question-" + answer.questionId + "-answer-" + answer.id}
                                                        onChange={(event) => handleAnswer(event, serviceQuestion.question.id, serviceQuestion.question.answerType, answer.id)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor={"question-" + answer.questionId + "-answer-" + answer.id}>
                                                        {translate(answer.answerCode, userData.language)}
                                                    </label>
                                                </div>
                                            )
                                        })) : (serviceQuestion.question.answers.map((answer) => {
                                            return (
                                                <div className="form-check" key={"questionGroup-" + answer.questionId + "-answer-" + answer.id}>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={"question-" + answer.questionId + "-answer-" + answer.id}
                                                        onChange={(event) => handleAnswer(event, serviceQuestion.question.id, serviceQuestion.question.answerType, answer.id)}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor={"question-" + answer.questionId + "-answer-" + answer.id}>
                                                        {translate(answer.answerCode, userData.language)}
                                                    </label>
                                                </div>
                                            )
                                        }))}
                                </div>
                            )
                        })}
                </div>
                <hr
                    className="axa-service-card-diveder"
                    style={{
                        display: (state.serviceCategories
                            ?.find(x => x.id === parseInt(state.selectedCatId))
                            ?.serviceSubCategories?.find(x => x.id === parseInt(state.selectedSubcatId))
                            ?.services.find(x => x.id === parseInt(state.selectedServiceId))
                            ?.serviceQuestions.length > 0 ? "" : "none")
                    }}
                />
                <div className="axa-newproject-second-title align-left pt-4 pb-4">{translate("newProjectDetailsSecondaryTitleDetails", userData.language)}</div>
                <div align="left">
                    <span className="axa-input-label align-left">{translate("newProjectDetailsLabelDetailText", userData.language)}</span>
                    <span> {translate("newProjectDetailsLabelOptional", userData.language)}</span>
                </div>
                <div className="row justify-content-left pt-1 pb-5">
                    <div className="col-12 col-md-7" align="left">
                        <textarea
                            className="form-control"
                            placeholder="..." rows="5"
                            value={state.customerDescription}
                            onChange={(event) => setState({ ...state, customerDescription: event.target.value })}
                        />
                    </div>
                </div>
                <div align="left">
                    <span className="axa-input-label align-left">{translate("newProjectDetailsLabelFile", userData.language)}</span>
                    <span> {translate("newProjectDetailsLabelOptional", userData.language)}</span>
                </div>
                <div {...getRootProps()} className="axa-input-file-div">
                    <img className="mt-5" src={uploadIcon} alt="file-upload" />
                    <input {...getInputProps()} />
                    {
                        isDragActive ?
                            <p>{translate("newProjectDetailsFileUploadDropHere", userData.language)}</p> :
                            <p>{translate("newProjectDetailsFileUploadDropDescription", userData.language)}</p>
                    }
                    <p>
                        {translate("newProjectDetailsFileUploadOR", userData.language)}
                    </p>
                    <button className="btn btn-outline-primary mb-5" onClick={open}>
                        <span className="axa-mobile-hidden">{translate("btnOpenFileDialog", userData.language)}</span>
                        <span className="d-md-none">{translate("btnOpenFileDialogMobile", userData.language)}</span>
                    </button>
                </div>
                <div className="mb-3" align="left">
                    <img src={InfoIcon} alt="info" />
                    <span className="ms-2">{translate("newProjectFileSizeAndTypeDescr", userData.language)}</span>
                </div>
                <div>
                    <table className="table table-striped" style={{ display: state.customerUploadedFiles.length > 0 ? "" : "none" }}>
                        <thead className="axa-files-table-header">
                            <tr>
                                <th></th>
                                <th className="axa-files-table-cell">{translate("newProjectFileTableFileNameHeader", userData.language)}</th>
                                <th className="text-center axa-files-table-cell">{translate("newProjectFileTableDeleteHeader", userData.language)}</th>
                            </tr>
                        </thead>
                        <tbody className="axa-files-table-body">
                            {state.customerUploadedFiles.map((file, index) => {
                                return (
                                    <tr key={"files-row-" + index}>
                                        <td className="axa-files-table-cell" align="right"><img src={FileIcon} alt="file" /></td>
                                        <td className="axa-files-table-cell">{file.name}</td>
                                        <td className="axa-files-table-cell" align="center">
                                            <button
                                                className="btn btn-sm"
                                                onClick={() => handleFileRemove(file.name)}
                                            >
                                                <img src={DeleteIcon} alt="delete file" />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className={"d-flex flex-column-reverse flex-md-row pt-4 " + (state.checkProviderResult === "not-found" ? "justify-content-end" : "justify-content-between")}>
                <button
                    className="btn text-secondary"
                    onClick={onBack}
                >
                    <FontAwesomeIcon className="me-1" icon={faArrowLeft} />
                    {translate("newProjectBack", userData.language)}
                </button>
                <button
                    className="btn btn-secondary"
                    onClick={onNext}
                    disabled={!state.answersComplete}
                >
                    {translate("btnProjectForward", userData.language)}
                    <FontAwesomeIcon className="ms-1" icon={faArrowRight} />
                </button>
            </div>
        </div>
    );
};

export default StepThree;
